import { useCallback } from 'react';
import { useVersionedCache } from './useVersionedCache';
import { cmsApi, Fee } from '../services/cmsApi';

/** Phí tính giá (data-driven) — cache version-gate + 24h. */
export function useChiPhi() {
  const fetcher = useCallback(async (): Promise<Fee[]> => {
    const data = await cmsApi.getChiPhi();
    if (!data) throw new Error('chi-phi rỗng');
    return data;
  }, []);

  // _v2: schema phí đổi từ object (nhóm) -> Fee[] (data-driven). Đổi key để bỏ hẳn cache cũ shape object.
  return useVersionedCache<Fee[]>('tuki_chiphi_cache_v2', fetcher);
}
